const UPDATE_BOOKFOR_PERSON = 'book/UPDATE_BOOKFOR_PERSON';
const UPDATE_BOOKFOR_ISLOADING = 'book/UPDATE_BOOKFOR_ISLOADING';
const UPDATE_BOOKFOR_SUGGESTIONS = 'person/UPDATE_BOOKFOR_SUGGESTIONS';

export default {
  UPDATE_BOOKFOR_PERSON,
  UPDATE_BOOKFOR_ISLOADING,
  UPDATE_BOOKFOR_SUGGESTIONS
};
